/* ── Admin User Management Module ── 
   Liner notes: Manejo de la crew y accesos. 
   Sincronización vía REST con el core del broadcast engine.
*/

import { authHeaders } from '../admin-auth.js';
import { showToast, showConfirm, escHtml } from '../admin-ui-base.js';

export async function openUsersModal() {
  const existingModal = document.getElementById('users-modal');
  if (existingModal) existingModal.remove();

  try {
    const res = await fetch('/auth/users', { headers: authHeaders() });
    if (!res.ok) return;
    const users = await res.json();
    
    const list = users.map(u => `
      <div class="user-row">
        <div class="user-info">
          <span class="user-name">${escHtml(u.username)}</span>
          <span class="user-email">${escHtml(u.email)}</span>
        </div>
        <div class="user-actions">
          ${u.is_admin ? `
            <button id="btn-revoke-${u.id}" class="btn-warn-small">QUITAR ADMIN</button>
            <span class="badge-admin">ADMIN</span>` : `
            <button id="btn-grant-${u.id}" class="btn-prime-small">HACER ADMIN</button>`}
          <button id="btn-del-${u.id}" class="btn-danger-small">BORRAR</button>
        </div>
      </div>
    `).join('');

    const modal = document.createElement('div');
    modal.id = 'users-modal';
    modal.className = 'users-overlay';
    modal.innerHTML = `
      <div class="users-card">
        <div class="users-header">
          <h2 class="crt-text">GESTIÓN DE USUARIOS</h2>
          <button id="close-users-modal" class="close-btn">✕</button>
        </div>
        <div class="users-list">${list || '<div class="empty-msg">Sin usuarios</div>'}</div>
        <div class="users-form">
          <h3 class="crt-text">NUEVO USUARIO</h3>
          <input id="new-user-username" placeholder="USERNAME">
          <input id="new-user-email" type="email" placeholder="EMAIL">
          <input id="new-user-pass" type="password" placeholder="CONTRASEÑA">
          <button id="btn-create-user" class="btn-create">CREAR USUARIO</button>
        </div>
      </div>
    `;
    
    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };
    document.body.appendChild(modal);

    // Event Listeners para evitar inline onclick (Estilo Moderno/Seguro)
    document.getElementById('close-users-modal').onclick = () => modal.remove();
    document.getElementById('btn-create-user').onclick = () => createUser(modal);

    users.forEach(u => {
      const grantBtn = document.getElementById(`btn-grant-${u.id}`);
      const revokeBtn = document.getElementById(`btn-revoke-${u.id}`);
      const delBtn = document.getElementById(`btn-del-${u.id}`);
      
      if (grantBtn) grantBtn.onclick = () => toggleUserAdmin(u.id, true);
      if (revokeBtn) revokeBtn.onclick = () => toggleUserAdmin(u.id, false);
      if (delBtn) delBtn.onclick = () => deleteUser(u.id);
    });

  } catch(e) { 
    showToast('ERROR CARGANDO USUARIOS', true); 
    console.error('[UsersModule] Error:', e);
  }
}

async function createUser(modal) {
  const username = document.getElementById('new-user-username').value.trim();
  const email = document.getElementById('new-user-email').value.trim();
  const password = document.getElementById('new-user-pass').value;
  if (!username || !email || !password) { 
    showToast('RELLENA TODOS LOS CAMPOS', true); 
    return; 
  }

  try {
    const res = await fetch('/auth/users', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ username, email, password })
    });
    if (res.ok) {
      showToast('USUARIO CREADO');
      modal.remove();
    } else {
      const data = await res.json();
      showToast(data.detail || 'ERROR', true);
    }
  } catch(e) { showToast('ERROR DE CONEXIÓN', true); }
}

async function toggleUserAdmin(userId, makeAdmin) {
  const usersModal = document.getElementById('users-modal');
  if (usersModal) usersModal.remove();
  
  try {
    const res = await fetch('/auth/users', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ user_id: userId, set_admin: makeAdmin })
    });
    if (res.ok) showToast(makeAdmin ? 'USUARIO ELEVADO A ADMIN' : 'ADMIN RETIRADO');
    else showToast('ERROR AL CAMBIAR ROL', true);
  } catch(e) { showToast('ERROR DE CONEXIÓN', true); }
}

function deleteUser(userId) {
  showConfirm('¿Seguro que quieres borrar este usuario?', async () => {
    const usersModal = document.getElementById('users-modal');
    if (usersModal) usersModal.remove();
    try {
      const res = await fetch(`/auth/users/${userId}`, { method: 'DELETE', headers: authHeaders() });
      if (res.ok) showToast('USUARIO BORRADO');
      else {
        const data = await res.json().catch(() => null);
        showToast((data && data.detail) || 'ERROR AL BORRAR', true);
      }
    } catch(e) { showToast('ERROR DE CONEXIÓN', true); }
  });
}
